function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M23.5 8.87c0-.065-.064-.118-.38-.169l-7.5-1.09-.117-.235L12.253.8C12.145.567 12.064.5 12 .5s-.145.067-.258.313L8.379 7.61l-.26.038L.887 8.7C.564 8.752.5 8.805.5 8.87c0 .053.065.177.21.334l5.438 5.29-.045.259-1.238 7.196a2.11 2.11 0 0 0-.023.22c0 .1.02.168.058.22 0 .002-.002 0 .047 0 .082 0 .195-.033.345-.115L12 18.748l.232.122 6.49 3.412a.693.693 0 0 0 .331.107c.038 0 .031.003.034-.001a.363.363 0 0 0 .057-.22c0-.102-.004-.177-.007-.204l-1.285-7.47.188-.184 5.231-5.102c.165-.164.229-.282.229-.338z"
});

var SvgIconStar = function SvgIconStar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon icon-star",
    width: 24,
    height: 23,
    fill: "#FFF",
    stroke: "#005FFF",
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-star.76c23c44.svg";
export { ForwardRef as ReactComponent };